"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var optionStyles = require("./components/MultiSelectInputList/MultiSelectInputList.scss");
var styles = require("./MultiSelectInput.scss");
var BaseCta_1 = require("../BaseCta");
var IconSvg_1 = require("../IconSvg");
var key_press_1 = require("../../../utils/key-press");
var Link_1 = require("./../Link");
var MultiSelectInputList_1 = require("./components/MultiSelectInputList");
var Tags_1 = require("./../Tags");
var Debounce_1 = require("../../../helpers/Functions/Debounce");
var react_dom_1 = require("react-dom");
var utils_1 = require("./../../../utils/utils");
var UserAgent_1 = require("../../../helpers/Functions/UserAgent");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var upArrowIsPressed = key_press_1.KeyPress.upArrowIsPressed;
var downArrowIsPressed = key_press_1.KeyPress.downArrowIsPressed;
var escIsPressed = key_press_1.KeyPress.escIsPressed;
var MultiSelectInput = /** @class */ (function (_super) {
    __extends(MultiSelectInput, _super);
    function MultiSelectInput(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.debouncedLog = Debounce_1.debounce(function (text) {
            _this.filterAndSetData(text);
        }, 300);
        _this.onChange = function (e) {
            var events = _this.props.events;
            var currentValue = e.target.value;
            if (currentValue) {
                _this.setState({ currentText: currentValue });
            }
            else {
                _this.setState({ isOpen: false, currentText: currentValue });
            }
            if (events && events.onChange) {
                events.onChange(e);
            }
            _this.debouncedLog(currentValue);
        };
        _this.filterAndSetData = function (txtValue) {
            var filteredData = _this.props.data.choices;
            if (txtValue) {
                filteredData = _this.props.data.choices.filter(function (choice) {
                    var searchText = txtValue.toUpperCase();
                    var displayText = choice.displayText.toUpperCase();
                    return displayText.includes(searchText);
                });
                // tslint:disable-next-line:no-console
                var isErrorText = filteredData.length === 0 && txtValue ? true : false;
                _this.setState({ isOpen: true, showClose: false, filteredData: filteredData, isErrorText: isErrorText });
            }
            else {
                _this.setState({ filteredData: [], isErrorText: false });
            }
        };
        _this.handleInputKeyDown = function (e) {
            var events = _this.props.events;
            if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
                if (_this.state.currentText) {
                    _this.selectGroupFilterTags();
                }
            }
            else if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
            }
            else if (_this.state.isOpen && downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var firstLi = el.querySelector("." + optionStyles.menuItem);
                if (firstLi) {
                    firstLi.focus();
                }
            }
            if (events && events.onKeyUp) {
                events.onKeyUp(e);
            }
            if (downArrowIsPressed(e) || upArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                e.preventDefault();
                if (liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                }
                return;
            }
        };
        _this.handleKeyDown = function (e) {
            var _a, _b;
            var events = _this.props.events;
            if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
                (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
                var elm = e.currentTarget.parentElement;
                var liElementMain = elm.querySelector("." + optionStyles.menuItem + ":focus");
                if (liElementMain && !liElementMain.prevElementSibling) {
                    _this.selectGroupFilterTags();
                }
            }
            else if (downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                var firstLi = el.querySelectorAll("." + optionStyles.menuItem);
                if (liElement && liElement.nextElementSibling) {
                    liElement.nextElementSibling.focus();
                }
                else {
                    if (firstLi && firstLi.length) {
                        firstLi[0].focus();
                    }
                }
                e.preventDefault();
                if (!UserAgent_1.isIE()) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                    return;
                }
            }
            else if (upArrowIsPressed(e)) {
                var elUp = e.currentTarget.parentElement;
                var liUpElement = elUp.querySelector("." + optionStyles.menuItem + ":focus");
                var lastLi = elUp.querySelectorAll("." + optionStyles.menuItem);
                if (liUpElement && liUpElement.previousElementSibling) {
                    liUpElement.previousElementSibling.focus();
                }
                else {
                    if (lastLi && lastLi.length > 1) {
                        lastLi[lastLi.length - 1].focus();
                    }
                }
                e.preventDefault();
            }
            else if (key_press_1.KeyPress.tabIsPressed(e)) {
                if (_this.state.isOpen) {
                    _this.setState({
                        showClose: true,
                    }, function () {
                        var _a, _b;
                        (_b = (_a = _this.closeRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                    });
                    e.preventDefault();
                }
            }
            if (events && events.handleKeyDown) {
                events.handleKeyDown(e);
            }
        };
        _this.onFocus = function (event) {
            var events = _this.props.events;
            _this.setState({ isOnFocus: true });
            if (events && events.onFocus) {
                events.onFocus(event);
            }
        };
        _this.handleClickOutside = function (event) {
            var domNode = react_dom_1.findDOMNode(_this);
            if (!domNode || !domNode.contains(event.target)) {
                _this.setState({
                    isOpen: false,
                });
            }
        };
        _this.onBlur = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            _this.setState({ isOnFocus: false });
            if (events && events.onBlur) {
                events.onBlur(currentText);
            }
        };
        _this.closeDropDown = function () {
            var _a, _b;
            _this.setState({
                isOpen: false,
                showClose: false,
                currentText: "",
            });
            (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        };
        _this.onSearchClick = function (event) {
            var elUp = event.currentTarget.parentElement;
            var liUpElement = elUp.querySelector("input");
            if (liUpElement) {
                liUpElement.focus();
                _this.setState({ isOnFocus: true });
            }
        };
        _this.onSelect = function (choice, enter) {
            var selectedTags = _this.state.selectedTags;
            var events = _this.props.events;
            selectedTags.push(choice);
            var unqSelectedTags = _this.getUniqueArray(selectedTags);
            var tagArray = unqSelectedTags.map(function (tag, index) {
                return {
                    children: tag.displayText,
                    options: {
                        type: "removable",
                    },
                    testId: "tag" + index,
                    events: {
                        onClick: function (e) {
                            _this.handleRemoveTag(e, tag);
                        },
                    },
                };
            });
            _this.setState({ selectedTags: unqSelectedTags, isOpen: false, currentText: "", tagArray: tagArray }, _this.handleTagsChange);
            if (events && events.onSelect) {
                events.onSelect(choice);
            }
        };
        _this.getUniqueArray = function (arr) {
            var e_1, _a;
            var result = [];
            var map = new Map();
            try {
                for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                    var item = arr_1_1.value;
                    if (!map.has(item.displayText)) {
                        map.set(item.displayText, true); // set any value to Map
                        result.push(item);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return result;
        };
        _this.selectGroupFilterTags = function () {
            var _a = _this.state, filteredData = _a.filteredData, selectedTags = _a.selectedTags;
            var updatedSelectedTags = __spread(filteredData, selectedTags);
            var unqSelectedTags = _this.getUniqueArray(updatedSelectedTags);
            var tagArray = unqSelectedTags.map(function (tag, index) {
                return {
                    children: tag.displayText,
                    options: {
                        type: "removable",
                    },
                    testId: "tag" + index,
                    events: {
                        onClick: function (e) {
                            _this.handleRemoveTag(e, tag);
                        },
                    },
                };
            });
            _this.setState({
                alertText: filteredData.length + " Channels Selected starting with " + _this.state.currentText,
            });
            _this.setState({
                selectedTags: unqSelectedTags,
                isOpen: false,
                currentText: "",
                tagArray: tagArray,
            }, _this.handleTagsChange);
            setTimeout(function () {
                _this.setState({ alertText: "" });
            }, 1000);
        };
        _this.handleRemoveTag = function (t, tag) {
            _this.removeSelectedTags(tag);
        };
        _this.removeSelectedTags = function (tag) {
            var _a, _b;
            var _c = _this.state, selectedTags = _c.selectedTags, tagArray = _c.tagArray;
            selectedTags = selectedTags.filter(function (tagItem) {
                return tag.displayText !== tagItem.displayText;
            });
            tagArray = tagArray.filter(function (tagItem) {
                return tag.displayText !== tagItem.children;
            });
            _this.setState({ selectedTags: selectedTags, isOpen: false, tagArray: tagArray }, _this.handleTagsChange);
            if (selectedTags.length === 0) {
                (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        };
        _this.handleTagsChange = function () {
            var events = _this.props.events;
            var selectedTags = _this.state.selectedTags;
            if (events && events.handleTagsChange) {
                events.handleTagsChange(selectedTags);
            }
        };
        _this.clearInput = function () {
            _this.setState({ currentText: "", isOpen: false, isOnFocus: true });
        };
        _this.onClearAll = function (event) {
            var _a, _b;
            var events = _this.props.events;
            event.stopPropagation();
            var elUp = event.currentTarget.parentElement;
            var inputElement = elUp.querySelector("input");
            if (inputElement) {
                inputElement.focus();
            }
            _this.setState({ isOpen: false, currentText: "", isOnFocus: true, selectedTags: [], tagArray: [] }, _this.handleTagsChange);
            if (events && events.onClearAll) {
                events.onClearAll();
            }
            (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        };
        _this.onNoSuggestionSelect = function () {
            _this.setState({ isOpen: false });
        };
        _this.searchIcon = function () {
            var _a, _b;
            return (React.createElement(React.Fragment, null,
                !_this.state.currentText.length ? (React.createElement("button", { "aria-label": (_a = _this.props.options) === null || _a === void 0 ? void 0 : _a.searchAriaLabelText, className: styles.icons + " pull-right border-none bg-transparent height-sm-all", onClick: _this.onSearchClick },
                    React.createElement(IconSvg_1.default, { size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M21.45 20A11 11 0 1020 21.45l8.26 8.26 1.42-1.42zM13 22a9 9 0 119-9 9 9 0 01-9 9z\"/></svg>" }))) : (""),
                _this.state.currentText.length ? (React.createElement(BaseCta_1.BaseCta, { className: styles.positionClose + " icon-close absolute color-ui-black", onClick: _this.clearInput, "aria-label": (_b = _this.props.options) === null || _b === void 0 ? void 0 : _b.closeAriaLabelText })) : ("")));
        };
        _this.getFindIndex = function (arr, displayText) {
            var _a;
            var index = -1;
            for (var i = 0; i < arr.length; i++) {
                if (((_a = arr[i]) === null || _a === void 0 ? void 0 : _a.displayText) === displayText) {
                    return i;
                }
            }
            return index;
        };
        _this.closeRef = React.createRef();
        _this.inputRef = React.createRef();
        _this.state = {
            selectedTags: [],
            isOpen: false,
            currentData: props.data,
            currentText: ((_a = props.data) === null || _a === void 0 ? void 0 : _a.value) ? props.data.value : "",
            currentValue: null,
            filteredData: [],
            isOnFocus: false,
            tagArray: [],
            isErrorText: false,
            showClose: false,
            alertText: "",
        };
        return _this;
    }
    MultiSelectInput.prototype.componentDidMount = function () {
        document.addEventListener("click", this.handleClickOutside, true);
    };
    MultiSelectInput.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleClickOutside, true);
    };
    MultiSelectInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, testId = _a.testId, id = _a.id, spi = _a.spi;
        var _b = this.state, selectedTags = _b.selectedTags, isOpen = _b.isOpen, filteredData = _b.filteredData, isOnFocus = _b.isOnFocus, currentText = _b.currentText, tagArray = _b.tagArray, isErrorText = _b.isErrorText, showClose = _b.showClose;
        var dropdownCls = isOpen
            ? [
                styles.dropdown,
                "block pad-none absolute overflow-hidden bg-transparent color-ui-dark-gray",
            ].join(" ")
            : [
                styles.dropdown,
                "absolute overflow-hidden hide bg-transparent  color-ui-dark-gray",
            ].join(" ");
        var choices = this.props.data.choices;
        var noDataFound = false;
        if (choices && choices.length === 0 && this.props.data.noSuggestionData) {
            choices = [this.props.data.noSuggestionData];
            noDataFound = true;
        }
        var grouptitleName = (options === null || options === void 0 ? void 0 : options.groupTitle) ? (options === null || options === void 0 ? void 0 : options.groupTitle) + " " : "";
        var groupTitle = function () {
            return (React.createElement(React.Fragment, null,
                grouptitleName,
                React.createElement("span", { className: "font-bold type-sm" }, currentText)));
        };
        var topOffsetList = function () { return ""; };
        return (React.createElement("div", { "data-test-id": testId, className: "rel font-regular color-ui-black flex-column flex" },
            React.createElement("div", { className: "mar-b-xxs" }, data.labelText && (React.createElement("label", { className: "font-medium type-sm", htmlFor: id }, data.labelText))),
            React.createElement("div", { className: "width-full" },
                React.createElement("div", { id: "multi-select-container", className: styles.inputClasses + " " + (isOnFocus ? "" + styles.inputFocusCss : " ") + " color-ui-dark-gray" },
                    React.createElement("input", { id: id, name: data.name, value: currentText, type: options === null || options === void 0 ? void 0 : options.inputType, placeholder: data.placeHolder, "aria-label": options.ariaLabelForInput ? options.ariaLabelForInput : undefined, "data-spi": spi, onChange: this.onChange, onKeyDown: this.handleInputKeyDown, onFocus: this.onFocus, onBlur: this.onBlur, tabIndex: 0, ref: this.inputRef }),
                    React.createElement("div", { id: "multi-select-list", className: dropdownCls },
                        React.createElement("ul", { role: "menu" },
                            currentText.length > 1 && filteredData.length > 0 ? (React.createElement("li", { "aria-hidden": "true", onKeyDown: this.handleKeyDown, className: optionStyles.menuItem +
                                    " " +
                                    " color-ui-dark-gray type-sm pad-t-xs" +
                                    " " +
                                    optionStyles.activeItem, tabIndex: 0, title: grouptitleName + currentText, onClick: this.selectGroupFilterTags, role: "menuitem" },
                                React.createElement("span", { "aria-hidden": "true" }, groupTitle()))) : (""),
                            (isErrorText && currentText && filteredData.length === 0) ||
                                currentText.length === 1 ? (React.createElement("li", { className: optionStyles.menuItem +
                                    " " +
                                    " type-sm pad-t-xs" +
                                    " " +
                                    optionStyles.activeItem +
                                    " " +
                                    styles.recordNotFound, title: options === null || options === void 0 ? void 0 : options.errorText, tabIndex: 0, role: "menuitem", onKeyDown: this.handleKeyDown },
                                React.createElement("span", null, options === null || options === void 0 ? void 0 : options.errorText))) : (""),
                            currentText.length > 1 &&
                                filteredData.map(function (choice, index) { return (React.createElement(MultiSelectInputList_1.default, { testId: utils_1.default(_this.props.testId, "Option"), key: choice.value, data: {
                                        choice: choice,
                                        isSelected: _this.getFindIndex(selectedTags, choice.displayText) !== -1
                                            ? true
                                            : false,
                                        textData: currentText || "",
                                    }, onSelect: noDataFound
                                        ? _this.onNoSuggestionSelect
                                        : _this.onSelect, options: { heighlightTextData: true }, handelKeyDown: _this.handleKeyDown })); })),
                        showClose && (React.createElement("button", { "aria-hidden": !isOpen, "aria-label": "Close dropdown", role: "button", className: "btn-small btn-primary-2", tabIndex: isOpen ? 0 : -1, ref: this.closeRef, onClick: this.closeDropDown }, "Close"))),
                    this.searchIcon())),
            React.createElement("div", { className: "mar-b-xxs" }, data.linkProps && (React.createElement(Link_1.default, __assign({}, data.linkProps, { className: "absolute top right solo pull-right" + " " + styles.link, onClick: this.onClearAll }), options === null || options === void 0 ? void 0 : options.linkText))),
            React.createElement("div", { className: styles.tags, id: "MultiSelectInputTags" },
                React.createElement(Tags_1.default, { data: tagArray, tagsType: "removable" })),
            React.createElement("div", { "aria-live": "assertive", role: "status" },
                React.createElement("span", { className: "hidden-spoken" },
                    " ",
                    this.state.alertText))));
    };
    return MultiSelectInput;
}(React.Component));
exports.default = MultiSelectInput;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/MultiSelectInput/MultiSelectInput.js
// module id = 1785
// module chunks = 8